import { Heading3, TextM } from 'app/components';
import { formatDateFromBackend } from 'app/helpers/dateHelpers';
import { formatCurrency, normalizeAddDigits } from 'app/utils/normalizer';
import {
  ApplicationDetailsHeader,
  ViewBoxContainer,
  ViewBoxContent,
  ViewBoxItem,
} from '../QualificationSideModal/styles';
import {
  TQualification,
  TQualificationWithStatusAndProduct,
} from 'modules/customer/interfaces/qualifications';

export interface IBorrowerContent {
  borrowerQualificationData: TQualification | undefined;
  selectedQualification: TQualificationWithStatusAndProduct | undefined;
}

const PersonContent = ({
  borrowerQualificationData,
  selectedQualification,
}: IBorrowerContent) => {
  return (
    <>
      <ApplicationDetailsHeader>
        <Heading3>Linha de crédito</Heading3>
      </ApplicationDetailsHeader>
      <ViewBoxContainer>
        <ViewBoxContent>
          <ViewBoxItem>
            <div>
              <TextM weight="Semibold">Status</TextM>
              <TextM>
                Última atualização:{' '}
                {formatDateFromBackend(
                  borrowerQualificationData?.updated_at || '',
                ).toLocaleDateString('pt-br')}
              </TextM>
            </div>
            <span>
              {selectedQualification?.status === 'APPROVED' ||
              selectedQualification?.status === 'QUALIFIED'
                ? 'Aprovado'
                : 'Cancelado'}
            </span>
          </ViewBoxItem>
        </ViewBoxContent>
      </ViewBoxContainer>

      <ApplicationDetailsHeader>
        <Heading3>Condições</Heading3>
      </ApplicationDetailsHeader>
      <ViewBoxContainer>
        <ViewBoxContent>
          <ViewBoxItem>
            <span>
              <TextM weight="Semibold">Limite total</TextM>
            </span>
            <span>
              <TextM>
                {selectedQualification?.condition?.line_of_credit?.credit_limit
                  ? formatCurrency(
                      selectedQualification?.condition?.line_of_credit
                        ?.credit_limit || 0,
                    )
                  : '-'}
              </TextM>
            </span>
          </ViewBoxItem>
        </ViewBoxContent>
        <ViewBoxContent>
          <ViewBoxItem>
            <span>
              <TextM weight="Semibold">Consumido</TextM>
            </span>
            <span>
              <TextM>
                {selectedQualification?.condition?.line_of_credit
                  ?.consumed_credit_limit
                  ? formatCurrency(
                      selectedQualification?.condition?.line_of_credit
                        ?.consumed_credit_limit || 0,
                    )
                  : '-'}
              </TextM>
            </span>
          </ViewBoxItem>
        </ViewBoxContent>
        <ViewBoxContent>
          <ViewBoxItem>
            <span>
              <TextM weight="Semibold">Taxa de juros (% a.m.)</TextM>
            </span>
            <span>
              <TextM>
                {borrowerQualificationData?.condition
                  ?.schedule_based_conditions?.[0].interest_rate
                  ? normalizeAddDigits(
                      borrowerQualificationData?.condition
                        ?.schedule_based_conditions?.[0]?.interest_rate * 100,
                      2,
                    )
                  : '-'}
              </TextM>
            </span>
          </ViewBoxItem>
        </ViewBoxContent>
      </ViewBoxContainer>
    </>
  );
};

export default PersonContent;
